const DarkTheme = {
  "--b1": "#000000",
  "--b2": "#1a1a1a",
  "--b3": "#2b2b2b",
  "--f1": "#FFFFFF",
  "--s1": "#33C9FF"
};

export default DarkTheme;
